import { createContext } from "react";
import { UserDetails } from "../modals/User";
import { CartProducts, CartTotals } from "../modals/Cart";

export interface AppContextInterface {
  auth: UserDetails | null;
  setAuth: (value: UserDetails | null) => void;
  cart: CartProducts[];
  cartTotals: CartTotals[];
  setCart: (value: CartProducts[] | []) => void;
  setCartTotals: (value: CartTotals[] | []) => void;
  tokenExpired: () => void
}

const defaultContext: AppContextInterface = {
  auth: null,
  cart: [],
  cartTotals: [],
  setAuth: () => {},
  setCart: () => {},
  setCartTotals: () => {},
  tokenExpired: () => {}
};

const AppContext = createContext(defaultContext);

export default AppContext;